import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=fad4094e&scoped=true&"
var script = {}
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=fad4094e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad4094e",
  null
  
)

export default component.exports